<app-side-menu>
  <div class="customer-form-content">
    <div class="row mb-4">
      <div class="col-12">
        <div class="page-header">
          <div>
            <h1 class="page-title">
              <i class="fas fa-user-group me-3"></i>
              {{ customerId ? 'Editar Cliente' : 'Novo Cliente' }}
            </h1>
            <p class="page-subtitle">{{ customerId ? 'Atualize as informações do cliente' : 'Cadastre um novo cliente no sistema' }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="customer-form-card">
          <app-form-shell
            [tabs]="availableTabs"
            [activeTab]="activeTab"
            (tabChange)="selectTab($event)">
          </app-form-shell>

          <div *ngIf="activeTab === 'identification'" class="form-section" [formGroup]="formStep1">
            <h3 class="section-title">
              <i class="fas fa-building me-2"></i>
              Identificação
            </h3>

            <div class="row g-3">
              <div class="col-md-6">
                <label for="personType" class="form-label">Tipo de Pessoa</label>
                <select id="personType" class="form-select" formControlName="personType">
                  <option value="Fisica">Física</option>
                  <option value="Juridica">Jurídica</option>
                </select>
              </div>
              <div class="col-md-6">
                <label for="name" class="form-label">{{ isPF ? 'Nome Completo' : 'Razão Social' }}</label>
                <input type="text" id="name" class="form-control" formControlName="name" [attr.placeholder]="isPF ? 'Digite o nome completo' : 'Digite a razão social'">
              </div>
              <div class="col-md-6" *ngIf="!isPF">
                <label for="tradeName" class="form-label">Nome Fantasia</label>
                <input type="text" id="tradeName" class="form-control" formControlName="tradeName" placeholder="Digite o nome fantasia">
              </div>
              <div class="col-md-6">
                <label for="documentNumber" class="form-label">{{ isPF ? 'CPF' : 'CNPJ' }}</label>
                <input 
                  type="text" 
                  id="documentNumber" 
                  class="form-control" 
                  [class.is-invalid]="documentAlreadyExists"
                  formControlName="documentNumber" 
                  [attr.placeholder]="isPF ? '000.000.000-00' : '00.000.000/0000-00'" 
                  (input)="onDocumentInput($event)">
                <div class="document-validation-status mt-1">
                  <div *ngIf="isCheckingDocument" class="d-flex align-items-center gap-2 text-primary">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <small>Verificando {{ isPF ? 'CPF' : 'CNPJ' }}...</small>
                  </div>
                  <div *ngIf="!isCheckingDocument && documentAlreadyExists && existingCustomerByDocument" class="text-danger">
                    <small>
                      <i class="fas fa-exclamation-triangle me-1"></i>
                      {{ isPF ? 'CPF' : 'CNPJ' }} já cadastrado para: <strong>{{ existingCustomerByDocument.name }}</strong>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <label for="stateRegistration" class="form-label">{{ isPF ? 'RG' : 'Inscrição Estadual' }}</label>
                <input 
                  type="text" 
                  id="stateRegistration" 
                  class="form-control" 
                  [class.is-invalid]="rgAlreadyExists"
                  formControlName="stateRegistration" 
                  [attr.placeholder]="isPF ? 'XX.XXX.XXX-X' : 'Digite a inscrição estadual ou ISENTO'" 
                  (input)="onStateRegistrationInput($event)">
                <div class="rg-validation-status mt-1" *ngIf="isPF">
                  <div *ngIf="isCheckingRG" class="d-flex align-items-center gap-2 text-primary">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <small>Verificando RG...</small>
                  </div>
                  <div *ngIf="!isCheckingRG && rgAlreadyExists && existingCustomerByRG" class="text-danger">
                    <small>
                      <i class="fas fa-exclamation-triangle me-1"></i>
                      RG já cadastrado para: <strong>{{ existingCustomerByRG.name }}</strong>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <label for="driverLicenseNumber" class="form-label">Número da CNH</label>
                <input 
                  type="text" 
                  id="driverLicenseNumber" 
                  class="form-control" 
                  formControlName="driverLicenseNumber" 
                  placeholder="Digite o número da CNH (11 dígitos)"
                  (input)="onDriverLicenseInput($event)"
                  maxlength="11">
              </div>
              <div class="col-md-6">
                <label for="driverLicenseExpiryDate" class="form-label">Data de Vencimento da CNH</label>
                <input 
                  type="date" 
                  id="driverLicenseExpiryDate" 
                  class="form-control" 
                  formControlName="driverLicenseExpiryDate">
              </div>
            </div>
          </div>

          <div *ngIf="activeTab === 'contact'" class="form-section" [formGroup]="formStep2">
            <h3 class="section-title">
              <i class="fas fa-address-book me-2"></i>
              Informações de Contato
            </h3>
            <div class="row g-3">
              <div class="col-md-6">
                <label for="email" class="form-label">E-mail do Cliente</label>
                <input 
                  type="email" 
                  id="email" 
                  class="form-control" 
                  formControlName="email" 
                  placeholder="exemplo@empresa.com"
                  (input)="onEmailInput($event)">
              </div>
              <div class="col-12">
                <div class="card border-0 shadow-sm">
                  <div class="card-body">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                      <h5 class="mb-0">
                        <i class="fas fa-address-book me-2"></i>
                        Contatos e Telefones
                      </h5>
                      <button type="button" class="btn btn-sm btn-outline-primary" (click)="addContact()">
                        <i class="fas fa-plus me-1"></i>
                        Adicionar contato
                      </button>
                    </div>

                    <div formArrayName="contacts" class="d-flex flex-column gap-3">
                      <div
                        class="border rounded p-3 bg-light"
                        *ngFor="let contactCtrl of contactsFormArray.controls; let i = index"
                        [formGroupName]="i">
                        <div class="row g-3">
                          <div class="col-md-3">
                            <label class="form-label">Tipo</label>
                            <select class="form-select" formControlName="contactType">
                              <option *ngFor="let type of contactTypeOptions" [value]="type">{{ type }}</option>
                            </select>
                          </div>
                          <div class="col-md-4">
                            <label class="form-label">Nome do contato</label>
                            <input type="text" class="form-control" formControlName="contactName" placeholder="Ex: João Silva">
                          </div>
                          <div class="col-md-3">
                            <label class="form-label">Telefone</label>
                            <input type="tel" class="form-control" formControlName="phoneNumber" placeholder="(11) 99999-9999" (input)="onContactPhoneInput(i, 'phoneNumber', $event)">
                          </div>
                          <div class="col-md-2 d-flex align-items-end">
                            <button type="button" class="btn btn-outline-danger w-100" (click)="removeContact(i)" [disabled]="contactsFormArray.length === 1">
                              <i class="fas fa-trash me-1"></i>
                              Remover
                            </button>
                          </div>
                          <div class="col-md-4">
                            <label class="form-label">Telefone secundário</label>
                            <input type="tel" class="form-control" formControlName="secondaryPhoneNumber" placeholder="(11) 99999-9999" (input)="onContactPhoneInput(i, 'secondaryPhoneNumber', $event)">
                          </div>
                          <div class="col-md-8 d-flex align-items-end">
                            <div class="form-check">
                              <input class="form-check-input" type="radio" name="defaultCustomerContact" [checked]="contactCtrl.get('isDefault')?.value" (change)="setDefaultContact(i)">
                              <label class="form-check-label">
                                Contato padrão
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <label for="customerCategory" class="form-label">Categoria</label>
                <select id="customerCategory" class="form-select" formControlName="customerCategory">
                  <option value="">Selecione uma categoria</option>
                  <option *ngFor="let cat of categoryOptions" [value]="cat.value">{{ cat.label }}</option>
                </select>
              </div>
              <div class="col-md-6">
                <label for="street" class="form-label">Logradouro</label>
                <input type="text" id="street" class="form-control" formControlName="street" placeholder="Digite o logradouro">
              </div>
              <div class="col-md-2">
                <label for="number" class="form-label">Número</label>
                <input type="text" id="number" class="form-control" formControlName="number" placeholder="Nº">
              </div>
              <div class="col-md-4">
                <label for="complement" class="form-label">Complemento</label>
                <input type="text" id="complement" class="form-control" formControlName="complement" placeholder="Apto, sala, etc.">
              </div>
              <div class="col-md-4">
                <label for="neighborhood" class="form-label">Bairro</label>
                <input type="text" id="neighborhood" class="form-control" formControlName="neighborhood" placeholder="Digite o bairro">
              </div>
              <div class="col-md-4">
                <label for="city" class="form-label">Cidade</label>
                <input type="text" id="city" class="form-control" formControlName="city" placeholder="Digite a cidade">
              </div>
              <div class="col-md-2">
                <label for="state" class="form-label">Estado</label>
                <input type="text" id="state" class="form-control" formControlName="state" placeholder="UF">
              </div>
              <div class="col-md-2">
                <label for="zipCode" class="form-label">CEP</label>
                <input type="text" id="zipCode" class="form-control" formControlName="zipCode" placeholder="00000-000" (input)="onZipCodeInput($event)">
                <div class="cep-status mt-1">
                  <div *ngIf="isLoadingCep" class="d-flex align-items-center gap-2">
                    <span class="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
                    <small>Buscando endereço...</small>
                  </div>
                  <div *ngIf="!isLoadingCep && cepError" class="text-danger">
                    <small>{{ cepError }}</small>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="activeTab === 'status'" class="form-section" [formGroup]="formStep3">
            <h3 class="section-title">
              <i class="fas fa-cog me-2"></i>
              Status e Configurações
            </h3>
            <div class="row g-3">
              <div class="col-md-6">
                <label for="status" class="form-label">Status do Cliente</label>
                <select 
                  id="status" 
                  class="form-select" 
                  formControlName="status"
                  [disabled]="loadingStatuses">
                  <option value="">Selecione um status</option>
                  <option 
                    *ngFor="let status of statuses" 
                    [value]="status.name">
                    {{ status.name }}
                  </option>
                </select>
                <div *ngIf="loadingStatuses" class="mt-2">
                  <div class="d-flex align-items-center gap-2 text-primary">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <small>Carregando status...</small>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <label for="notes" class="form-label optional">Observações</label>
                <textarea id="notes" class="form-control" formControlName="notes" rows="4" placeholder="Informações adicionais sobre o cliente..."></textarea>
              </div>
            </div>
          </div>

          <!-- Aba: Dados Bancários -->
          <div *ngIf="activeTab === 'payments'" class="form-section" [formGroup]="formStep4">
            <h3 class="section-title">
              <i class="fas fa-credit-card me-2"></i>
              Dados Bancários
            </h3>
            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label">Nome do Banco</label>
                <select class="form-select" formControlName="bankName">
                  <option value="">Selecione o banco</option>
                  <option *ngFor="let bank of BANKS_OPTIONS" [value]="bank.value">
                    {{ bank.label }}
                  </option>
                </select>
              </div>
              <div class="col-md-3">
                <label class="form-label">Agência</label>
                <input type="text"
                       class="form-control"
                       formControlName="agency"
                       placeholder="Ex: 1234-5"
                       maxlength="8"
                       (input)="applyAgencyMask($event)">
              </div>
              <div class="col-md-3">
                <label class="form-label">Tipo de Conta</label>
                <select class="form-select" formControlName="accountType">
                  <option value="">Selecione o tipo</option>
                  <option *ngFor="let type of ACCOUNT_TYPE_OPTIONS" [value]="type.value">
                    {{ type.label }}
                  </option>
                </select>
              </div>
              <div class="col-md-6">
                <label class="form-label">Número da Conta</label>
                <input type="text"
                       class="form-control"
                       formControlName="accountNumber"
                       placeholder="Ex: 12345-6"
                       maxlength="20"
                       (input)="applyAccountNumberMask($event)">
              </div>
              <div class="col-md-6">
                <label class="form-label">Nome do Titular</label>
                <input type="text" class="form-control" formControlName="accountHolderName" placeholder="Nome completo do titular">
              </div>
              <div class="col-md-6">
                <label class="form-label">Chave PIX</label>
                <input type="text" class="form-control" formControlName="pixKey" placeholder="CPF, CNPJ, e-mail, telefone ou chave aleatória">
              </div>
            </div>
          </div>

          <!-- Aba: Documentos -->
          <div *ngIf="activeTab === 'documents'" class="form-section">
            <h3 class="section-title">
              <i class="fas fa-paperclip me-2"></i>
              Documentos do Cliente
            </h3>

            <p class="text-muted mb-3">
              Anexe documentos do cliente quando necessário.
            </p>

            <div *ngIf="uploading" class="upload-progress mb-3">
              <div class="d-flex justify-content-between mb-2">
                <span>Enviando arquivo...</span>
                <span>{{ uploadProgress }}%</span>
              </div>
              <div class="progress">
                <div class="progress-bar" [style.width.%]="uploadProgress"></div>
              </div>
            </div>

            <div *ngIf="isLoadingAttachments" class="text-center py-4">
              <span class="spinner-border spinner-border-sm me-2" role="status"></span>
              Carregando documentos...
            </div>

            <div *ngIf="!isLoadingAttachments" class="documents-table">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th style="width: 40%">Tipo de Documento</th>
                    <th style="width: 35%">Arquivo Anexado</th>
                    <th style="width: 25%" class="text-center">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let docType of documentTypes">
                    <td>
                      <i class="fas {{ docType.icon }} me-2"></i>
                      <strong>{{ docType.label }}</strong>
                    </td>
                    <td>
                      <div *ngIf="getAttachmentsByType(docType.code).length === 0" class="text-muted">
                        <i class="fas fa-times-circle text-danger me-1"></i>
                        Nenhum arquivo anexado
                      </div>
                      <div *ngIf="getAttachmentsByType(docType.code).length > 0">
                        <div *ngFor="let att of getAttachmentsByType(docType.code)" class="mb-2">
                          <i class="fas fa-file text-success me-1"></i>
                          <span>{{ att.originalFileName }}</span>
                          <button 
                            type="button" 
                            class="btn btn-sm btn-link text-danger p-0 ms-2" 
                            (click)="removeAttachment(att)"
                            title="Remover">
                            <i class="fas fa-trash"></i>
                          </button>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <label [for]="'fileInput-' + docType.code" class="btn btn-sm btn-primary mb-0">
                        <i class="fas fa-upload me-1"></i>
                        Anexar
                      </label>
                      <input 
                        [id]="'fileInput-' + docType.code" 
                        type="file" 
                        style="display: none"
                        (change)="onAttachmentFileSelected($event, docType.code)"
                        accept="image/*,.pdf" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="form-actions">
            <div class="wizard-actions">
              <app-button 
                text="Voltar"
                color="var(--secondary-color)"
                (buttonClick)="prevStep()"
                [disabled]="currentStep === 1">
                <i class="fas fa-arrow-left me-2"></i>
              </app-button>

              <app-button 
                text="Cancelar"
                color="#dc3545"
                (buttonClick)="cancel()">
                <i class="fas fa-times me-2"></i>
              </app-button>

              <div class="spacer"></div>

              <button 
                *ngIf="currentStep < 4" 
                type="button" 
                class="btn btn-primary" 
                (click)="nextStep()">
                Avançar
              </button>
              <button 
                *ngIf="currentStep === 4" 
                type="button" 
                class="btn btn-success" 
                (click)="save()"
                [disabled]="isSubmitting">
                <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                {{ isSubmitting ? 'Salvando...' : 'Salvar Cliente' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>


